module.exports = __webpack_public_path__ + "static/img/autCt_bg_white_03.cd8d1315.svg";